"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveProviderBinding = void 0;
const resolveProviderBindingCallback_1 = require("../calculations/resolveProviderBindingCallback");
const resolveSingletonScopedBinding_1 = require("./resolveSingletonScopedBinding");
exports.resolveProviderBinding = (0, resolveSingletonScopedBinding_1.resolveSingletonScopedBinding)(resolveProviderBindingCallback_1.resolveProviderBindingCallback);
//# sourceMappingURL=resolveProviderBinding.js.map